<template>
  <v-dialog
    v-model="visible"
    v-if="form !== null"
    width="60vw"
    max-width="90vw"
    persistent
  >
    <v-card>
      <v-card-title>
        <p class="headline">マップレポート新規申請</p>
        <small style="margin-left: 15px" class="red--text block">
          <span>
            ※ マップレポートは10万円以上の出稿の場合のみ申請できます。<br />
            ※ マップレポートの発行は配信終了後となります。
          </span>
        </small>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs3>案件名（必須）</v-flex>
          <v-flex xs9>
            <v-autocomplete
              @change="changeInsertionOrder"
              :items="form.insertionOrderList"
              :item-text="item => createItemText(item)"
              label="案件名"
              item-value="id"
              no-data-text="No data"
              append-icon="search"
              solo
              placeholder="案件名を選択してください。"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs3>レポート名（必須）</v-flex>
          <v-flex xs9>
            <v-text-field v-model="form.name" />
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs3>
            <span>抽出期間（必須）</span>
          </v-flex>
          <v-flex xs9>
            <v-radio-group
              :value="periodType"
              @change="onChangeStatus($event)"
              row
            >
              <v-radio
                v-for="(item, index) in periodTypeItems"
                :key="index"
                :label="item.text"
                :value="item.value"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout v-if="!isAllPeriod" wrap>
          <v-flex xs3 />
          <v-flex xs9>
            <AppFormPeriodPicker
              :start="form.extractionStartDate"
              :end="form.extractionEndDate"
              :disabled="false"
              :disabledAlreadyStart="false"
              :isDateRestrictions="true"
              :isStartDateLimit="false"
              :usableStartDateFilter="usableStartDateFilter"
              :usableEndDateFilter="usableEndDateFilter"
              @inputStartDate="onInputStartDate"
              @inputEndDate="onInputEndDate"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <AppButtonCancel @click="close">キャンセル</AppButtonCancel>
        <v-btn @click="submit()" :disabled="!isValid" color="primary">
          申請
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MapReportRepository } from '@/models/MapReport/MapReportRepository'
import { mapReportFormFactory } from '@/models/MapReport'
import dayjs from 'dayjs'

const PERIOD_TYPE = {
  ALL: 'all',
  DESIGNATION: 'designation',
}

const periodTypeItems = [
  {
    value: PERIOD_TYPE.ALL,
    text: `${dayjs()
      .subtract(1, 'd')
      .format('YYYY-MM-DD')}までの全期間`,
  },
  {
    value: PERIOD_TYPE.DESIGNATION,
    text: '期間指定',
  },
]

export default {
  name: 'MapReportRequestModalAdd',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      periodType: PERIOD_TYPE.ALL,
      form: null,
    }
  },
  computed: {
    periodTypeItems() {
      return periodTypeItems
    },
    isAllPeriod() {
      return this.periodType === PERIOD_TYPE.ALL
    },
    isValid() {
      return this.form.isCreateValid(this.periodType === PERIOD_TYPE.ALL)
    },
  },
  async created() {
    // form作成
    this.form = await mapReportFormFactory(this.$route.params.advertiserId)
    this.form.setExtractionDefaultDay()
  },
  methods: {
    createItemText(item) {
      return item.name + ' (' + item.anIoId + ')'
    },
    changeInsertionOrder(value) {
      const selectedInsertionOrder = this.form.insertionOrderList.find(
        io => io.id === value,
      )
      if (selectedInsertionOrder === undefined) {
        return
      }
      this.form.insertionOrderId = selectedInsertionOrder.id
      this.form.insertionOrderName = selectedInsertionOrder.name
      this.form.name = `${this.form.insertionOrderName} マップレポート`
    },
    onChangeStatus(periodType) {
      this.periodType = periodType
      if (periodType === PERIOD_TYPE.ALL) this.form.setExtractionDefaultDay()
    },
    close() {
      this.$emit('cancel')
    },
    onInputStartDate(date) {
      this.form.extractionStartDate = `${date} 00:00:00`
      if (!this.form.extractionEndDate)
        this.form.extractionEndDate = `${date} 23:59:59`
    },
    onInputEndDate(date) {
      this.form.extractionEndDate = `${date} 23:59:59`
    },
    async submit() {
      const body = `通常マップレポートの発行には、5営業日程度いただいております。<br />発行が完了次第、ご登録メールアドレスに「マップレポート発行のお知らせ」をメールで通知いたします。`
      const result = await this.$confirm(
        'マップレポート申請をしてもよろしいですか？',
        { body },
      )
      if (!result) {
        return
      }
      try {
        await MapReportRepository.create(
          this.form,
          this.$route.params.advertiserId,
        )
        this.$emit('clickExec')
      } catch (e) {
        console.error(e)
        throw new Error('マップレポート申請に失敗しました')
      }
    },
    usableStartDateFilter(date) {
      if (dayjs(date).isAfter(dayjs().subtract(1, 'd'))) return false
      if (dayjs(date).isAfter(dayjs(this.form.extractionEndDate))) return false
      return true
    },
    usableEndDateFilter(date) {
      if (dayjs(date).isAfter(dayjs().subtract(1, 'd'))) return false
      if (dayjs(date).isBefore(dayjs(this.form.extractionStartDate)))
        return false
      return true
    },
  },
}
</script>

<style scoped></style>
